export const INVOICE_TYPES = ['Hearing Aid', 'Cochlear Implant', 'Diagnostics', 'Marketing', 'Repair', 'Accessories'];

export const normalizePhone = (p) => {
  let d = String(p || '').replace(/\D/g, '');
  if (d.length === 12 && d.startsWith('91')) d = d.slice(2);
  else if (d.length === 11 && d.startsWith('0')) d = d.slice(1);
  return d;
};

// Mandatory on every SO / Invoice: Name, Phone (10 digits), Lead Source, Audiologist, Invoice Type.
export const coreFieldsError = ({ name, phone, leadSource, audiologist, invoiceType }) => {
  const missing = [
    ['Customer Name', name], ['Phone', phone], ['Lead Source', leadSource],
    ['Audiologist', audiologist], ['Invoice Type', invoiceType],
  ].filter(([, v]) => !String(v || '').trim()).map(([l]) => l);
  if (missing.length) return `Required: ${missing.join(', ')}`;
  if (normalizePhone(phone).length !== 10) return 'Phone must be a valid 10-digit mobile number';
  return '';
};
